import { Collapse } from 'antd';
import Link from 'next/link';
import { Tweet } from 'react-twitter-widgets';
import { useIntercom } from 'react-use-intercom';
import styled from 'styled-components';

import CuriOpenArms from '../../../assets/icons/CuriOpenArms';
import StaarPrepSvg from '../../../assets/icons/StaarPrepSvg';
import Brent from '../../../assets/images/LandingPage/Brent.png';
import SchoolLogo2 from '../../../assets/images/LandingPage/CISDlogo.png';
import Claudia from '../../../assets/images/LandingPage/Claudia.png';
import DickinsonISD from '../../../assets/images/LandingPage/DickinsonISD.png';
import ESC19 from '../../../assets/images/LandingPage/ESC19.png';
import FriscoIsd from '../../../assets/images/LandingPage/FriscoIsd.png';
import Heather from '../../../assets/images/LandingPage/Heather.png';
import SchoolLogo3 from '../../../assets/images/LandingPage/MVISDlogo.png';
import ParticipantFeedback from '../../../assets/images/LandingPage/participantFeedback.png';
import SchoolLogo1 from '../../../assets/images/LandingPage/SANBENITOlogo.png';
import theme from '../../../assets/theme';
import { useBreakPoint } from '../../../hooks/useBreakPoint';
import { useMarketingMetrics } from '../../../providers/PlausibleAnalyticsProvider';
import { Button } from '../../_atoms/Button';
import { IconWrapper } from '../../_atoms/IconWrapper';
import { NextPageWithLayout } from '../../layouts';
import { FAQSection } from '../PricingPageContent/PricingPageContent';

const GreenSection = styled.section`
  background-color: ${theme.colors.green};
  padding: 40px 20px;
  text-align: center;
  color: white;

  h2 {
    font-size: 30px;
    color: white;
    max-width: 900px;
    margin: 0 auto;
  }

  h3 {
    font-size: 24px;
    color: white;
    max-width: 900px;
    margin: 0 auto;
  }

  p {
    font-size: 20px;
    font-weight: normal;
  }

  @media (max-width: 700px) {
    padding: 40px 10px;
  }
`;

const BeigeSecton = styled.section`
  background-color: ${theme.colors.background};
  padding: 40px 20px;
  text-align: center;

  h2 {
    font-size: 30px;
    max-width: 900px;
    margin: 0 auto;
  }

  p {
    font-size: 20px;
    font-weight: normal;
  }

  @media (max-width: 700px) {
    padding: 40px 10px;
  }
`;

const ColumnsWrapper = styled.div<{ columnNumber?: number }>`
  display: grid;
  grid-template-columns: repeat(${props => props.columnNumber || 2}, 1fr);
  gap: 20px;
  margin: 0 auto;
  max-width: 900px;
  align-items: center;

  h2 {
    text-align: left;
  }

  p {
    text-align: left;
    font-weight: normal;
    font-size: 18px;
  }

  @media (max-width: 880px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

const SchoolLogosGrid = styled.div`
  display: grid;
  justify-content: center;

  margin: 0 auto;
  grid-template-columns: repeat(3, 150px);
  gap: 20px;
  margin-top: 20px;
  align-items: center;

  img {
    justify-self: center;
    max-height: 100px;
    max-width: 100%;
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(1, 150px);
  }
`;

const InnovativeDistricts = () => {
  return (
    <BeigeSecton>
      <h2>Join the most innovative districts in Texas</h2>
      <SchoolLogosGrid>
        <img src={SchoolLogo1.src} alt="Sanbenito school logo" />
        <img src={SchoolLogo2.src} alt="CISD school logo" />
        <img src={SchoolLogo3.src} alt="Sanbenito school logo" />
      </SchoolLogosGrid>
    </BeigeSecton>
  );
};

const EngagingTEKS = () => {
  const isLargerThan800 = useBreakPoint(800);

  return (
    <GreenSection>
      <h2 style={{ fontSize: 20 }}>
        Get access to <strong>thousands of engaging TEKS aligned practice lessons</strong>{' '}
        for the SCR & ECR parts of the reading language arts STAAR tests
      </h2>
      <InfoContainer>
        <BubblesContainer>
          <InfoBubble>
            <p>Extended constructed response (ECR)</p>
          </InfoBubble>
          <InfoBubble>
            <p>Short constructed response (SCR)</p>
          </InfoBubble>
          <InfoBubble>
            <p>Revising and editing (SCR)</p>
          </InfoBubble>
        </BubblesContainer>
        {isLargerThan800 && (
          <div style={{ alignSelf: 'center' }}>
            <CuriOpenArms />
          </div>
        )}
        <BubblesContainer>
          <InfoBubble>
            <p>Fiction</p>
          </InfoBubble>
          <InfoBubble>
            <p>Non-fiction</p>
          </InfoBubble>
          <InfoBubble>
            <p>Poems</p>
          </InfoBubble>
          <InfoBubble>
            <p>Paired passages</p>
          </InfoBubble>
        </BubblesContainer>
      </InfoContainer>
      <h3 style={{ marginTop: 40, marginBottom: 20 }}>Check out our STAAR generators</h3>
      <GeneratorLinkButtonsContainer>
        <Link
          href={
            'https://curipod.com/generators/Revision-and-Editing-Prep-SCR-STAAR/g/8098a458-31b1-47a5-932b-e0ba15dcadf7'
          }
        >
          <a>
            <Button
              icon={
                <IconWrapper height={'30px'} width={'30px'} color={theme.colors.black}>
                  <StaarPrepSvg />
                </IconWrapper>
              }
            >
              SCR - Revision and Editing Prep
            </Button>
          </a>
        </Link>
        <Link
          href={
            'https://curipod.com/generators/ECR---Informational-Composition-Prep-STAAR/g/5b12ae9c-eb7a-46c8-bb2f-6d71a2f3b6c8'
          }
        >
          <a>
            <Button
              icon={
                <IconWrapper height={'30px'} width={'30px'} color={theme.colors.black}>
                  <StaarPrepSvg />
                </IconWrapper>
              }
            >
              ECR - Informational Composition Prep{' '}
            </Button>
          </a>
        </Link>
        <Link
          href={
            'https://curipod.com/generators/SCR-Reading-Prep---Fiction-STAAR/g/545d1945-51ff-43af-8a0c-d96fc953dd41'
          }
        >
          <a>
            <Button
              icon={
                <IconWrapper height={'30px'} width={'30px'} color={theme.colors.black}>
                  <StaarPrepSvg />
                </IconWrapper>
              }
            >
              SCR Reading Prep - Fiction{' '}
            </Button>
          </a>
        </Link>
        <Link
          href={
            'https://curipod.com/generators/SCR-Reading-Prep---Non-Fiction-STAAR/g/4e28c178-f50e-4c89-8772-1d8f15a53d56'
          }
        >
          <a>
            <Button
              icon={
                <IconWrapper height={'30px'} width={'30px'} color={theme.colors.black}>
                  <StaarPrepSvg />
                </IconWrapper>
              }
            >
              SCR Reading Prep - Non-Fiction{' '}
            </Button>
          </a>
        </Link>
      </GeneratorLinkButtonsContainer>
    </GreenSection>
  );
};

const GeneratorLinkButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;

  span {
    width: 200px;
    display: block;
    word-wrap: break-word;
    white-space: normal;
    color: ${theme.colors.black};
  }

  button {
    background-color: ${theme.colors.white};
    width: 250px;
  }

  button:hover,
  button:focus {
    background-color: ${theme.colors.greyLight};
  }
`;

const InfoBubble = styled.div`
  background-color: white;
  color: ${theme.colors.black};
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 100%;
  p {
    margin: 0;
    font-weight: normal;
    font-size: 20px;
  }

  @media (max-width: 700px) {
    p {
      font-size: 16px;
    }
  }
`;

const InfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
  width: 100%;
  max-width: 800px;
  margin: 0px auto;
  padding-top: 20px;
`;

const BubblesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: start;
  align-items: center;
  width: 100%;
  @media (max-width: 700px) {
    margin-bottom: 20px;
  }
`;

const EvidenceBasedFeedback = () => {
  return (
    <BeigeSecton>
      <ColumnsWrapper>
        <div>
          <h2>Evidence based feedback driving results</h2>
          <p>
            When students submit their SCR or ECR they get immediate feedback and expected
            grade from AI based on the STAAR rubrics.
          </p>
          <p>
            The alternative is teachers spending 10 hours grading, and students would get
            the feedback a week later
          </p>
        </div>
        <ImageWrapper>
          <img src={ParticipantFeedback.src} alt="participand device with feedback" />
        </ImageWrapper>
      </ColumnsWrapper>
    </BeigeSecton>
  );
};

const ImageWrapper = styled.div`
  img {
    max-width: 100%;
  }
  p {
    font-size: 12px;
    font-weight: normal;
    text-align: center;
  }
`;

const ImproveStaarScores = () => {
  const { Panel } = Collapse;
  const items: {
    key: string;
    label: string;
    content: JSX.Element;
  }[] = [
    {
      key: '1',
      label: 'TEKS Aligned',
      content: (
        <p>
          Our lessons are aligned with the TEKS standards and the questions and rubrics
          match the STAAR form and style.
        </p>
      ),
    },
    {
      key: '2',
      label: 'Endless Lessons',
      content: (
        <p>
          Generate 1000s of full lessons with reading passages and STAAR questions with AI
          on topics your students care about.
        </p>
      ),
    },
    {
      key: '3',
      label: 'Track Improvement',
      content: (
        <p>
          Generate classroom and individual reports with one click so you can follow up
          progress this test season.
        </p>
      ),
    },
    {
      key: '4',
      label: 'Simple & flexible implementation',
      content: (
        <p>
          Curipod seamlessly integrates into your current curriculum. Build test prep
          that’s ready to use in less than 1 minute.
        </p>
      ),
    },
    {
      key: '5',
      label: 'FERPA & COPPA compliant',
      content: (
        <p>
          Student privacy is a top priority. Curipod is compliant with FERPA, COPPA and
          other state laws
        </p>
      ),
    },
  ];

  return (
    <GreenSection>
      <h2>Ready to improve STAAR scores?</h2>
      <p>Let us show you engaging test prep that students enjoy</p>
      <StyledCollapse defaultActiveKey={['1']}>
        {items.map(item => (
          <Panel header={item.label} key={item.key}>
            {item.content}
          </Panel>
        ))}
      </StyledCollapse>
    </GreenSection>
  );
};

const StyledCollapse = styled(Collapse)`
  font-size: 18px;
  font-family: 'Nunito';
  border: none;
  padding: 20px;
  background: ${theme.colors.white};
  max-width: 900px;
  margin: 0 auto;

  p {
    margin: 0;
    text-align: left;
    font-weight: normal;
  }

  a {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
  svg {
    width: 18px;
    height: 18px;
  }
  .ant-collapse-item .ant-collapse-header {
    color: ${theme.colors.black};
    font-weight: bold;
    font-size: 20px;
  }

  .ant-collapse-item {
    border: none;
    border-bottom: 1px solid #00000020;
    border-radius: 0px !important;
  }
  .ant-collapse-item.ant-collapse-item.ant-collapse-item-active {
    border-bottom: none;
  }

  .ant-collapse-content {
    border: none;
  }

  .ant-collapse-item:last-child > .ant-collapse-content {
    border-radius: 10px;
  }

  @media (max-width: 500px) {
    .ant-collapse-item .ant-collapse-header {
      font-size: 14px;
    }
    p {
      font-size: 14px;
    }
  }
`;

const SchoolsAndDistrictsPlan = () => {
  const { track } = useMarketingMetrics();
  const { trackEvent } = useIntercom();
  return (
    <BeigeSecton>
      <ColumnsWrapper>
        <ImageWrapper>
          <img src={ESC19.src} alt="participand device with feedback" />
          <p>Curipod is an awarded vendor on the buy board for ESC-Region 19 </p>
        </ImageWrapper>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 30,
          }}
        >
          <h2>
            RLA STAAR practice lessons are included with Curipod’s school & district plan.
            $3,999 per school site/year
          </h2>
          <Link href={'https://meetings.hubspot.com/eirik-berre/texas-sales-meetings'}>
            <a
              onClick={() => {
                track('StaarTestPrepPage.BookAMeeting.clicked');
                trackEvent('StaarTestPrepPage.BookAMeeting');
              }}
              target="__blank"
              rel="noopener noreferrer"
            >
              <QuoteButton>Book a meeting</QuoteButton>
            </a>
          </Link>
        </div>
      </ColumnsWrapper>
    </BeigeSecton>
  );
};

const QuoteButton = styled(Button)`
  background-color: ${theme.colors.orange};
  color: ${theme.colors.white};

  &:hover,
  &:focus {
    background-color: ${theme.colors.orange};
  }
`;

const WhatAdminsSay = () => {
  return (
    <GreenSection>
      <h2 style={{ marginBottom: 20 }}>
        What admins and teachers say about Curipod&apos;s STAAR test prep
      </h2>
      <ColumnsWrapper style={{ alignItems: 'start' }} columnNumber={2}>
        <Quote>
          <p>
            “I am loving the SCR generator but I can&apos;t wait to try the revising and
            editing generator! They are such an AMAZING way for students to get authentic,
            rigorous practice without having to reinvent the wheel!!”
          </p>
          <ProfileImageWrapper>
            <ProfileImage>
              <img src={FriscoIsd.src} alt="Kristine Seale Frisco ISD teacher" />
            </ProfileImage>
            <p>Kristine Seale, Digital Learning Coach, Frisco ISD</p>
          </ProfileImageWrapper>
        </Quote>
        <Quote>
          <p>
            “My 8th graders beg to do SCRs on this. My &quot;toughest&quot; kids were
            jumping out of their seats in excitement when they applied their prior
            feedback and began receiving 2s.”
          </p>
          <ProfileImageWrapper>
            <ProfileImage>
              <img src={DickinsonISD.src} alt="Claudia Curipod teacher" />
            </ProfileImage>
            <p>Haley Miller, Teacher, Dickinson ISD</p>
          </ProfileImageWrapper>
        </Quote>
        <Quote>
          <p>
            “The RLA STAAR generator is a powerful and versatile tool packed with rich and
            customizable content, allowing teachers the flexibility to curate endless
            thought provoking SCR prompts. As a mega bonus, this generator lends itself
            for class discussions, full reading text with comprehension promptings, and
            even an opportunity for students to share their preferences on future
            topics…genius!”
          </p>
          <ProfileImageWrapper>
            <ProfileImage>
              <img src={Claudia.src} alt="Claudia Curipod teacher" />
            </ProfileImage>
            <p>Claudia Garcia, Garcia Middle School (Brownsville ISD), 6th ESL/ELAR</p>
          </ProfileImageWrapper>
        </Quote>
        <Quote>
          <p>
            “The SCR generator is a game changer for my teachers. They can easily save
            time using this generator with students and the students are engaged while
            prepping for the test without even realizing it!”
          </p>
          <ProfileImageWrapper>
            <ProfileImage>
              <img src={Brent.src} alt="Brent Curipod teacher" />
            </ProfileImage>
            <p>Brent Mischnick, Innovation Leader, Castleberry ISD</p>
          </ProfileImageWrapper>
        </Quote>
        <Quote>
          <p>
            “Curipods RLA STAAR generator assists teachers in giving immediate feedback on
            student writings. With state rubric guidelines the interactive lesson allows
            for guidance and direction on improving student generated essays. Teachers are
            able to collect data and adjust instruction without spending hours grading
            individual papers.”
          </p>
          <ProfileImageWrapper>
            <ProfileImage>
              <img src={Heather.src} alt="Heather Curipod teacher" />
            </ProfileImage>
            <p>Heather Brantley, TE Web Communications and CEER at Pine Tree ISD</p>
          </ProfileImageWrapper>
        </Quote>
      </ColumnsWrapper>
    </GreenSection>
  );
};

const Quote = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  max-width: 900px;
  color: white;
  text-align: center;
  margin: 10px 10px 20px 10px;

  p {
    margin: 0;
  }
  h2 {
    margin: 0;
  }
`;

const ProfileImage = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
`;

const ProfileImageWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  justify-content: center;
  align-items: center;
  gap: 10px;
  max-width: 300px;
  margin: 0 auto;

  p {
    font-size: 14px;
    font-weight: normal;
  }
`;

const Tweets = () => {
  return (
    <BeigeSecton>
      <TweetGrid>
        <Tweet tweetId="1689813769029820416" />

        <Tweet tweetId="1686180615077433346" />

        <Tweet tweetId="1689756295920746496" />

        <Tweet tweetId="1689768899376537601" />

        <Tweet tweetId="1686845883806056448" />

        <Tweet tweetId="1689992962279710720" />
      </TweetGrid>
    </BeigeSecton>
  );
};

const TweetGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 300px);
  gap: 20px;
  justify-content: center;
  max-width: 1000px;
  margin: 0 auto;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const StaarTestPrepPageContent: NextPageWithLayout = () => {
  return (
    <Container>
      <InnovativeDistricts />
      <EngagingTEKS />
      <EvidenceBasedFeedback />
      <ImproveStaarScores />
      <SchoolsAndDistrictsPlan />
      <WhatAdminsSay />
      <Tweets />
      <FAQSection />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

export default StaarTestPrepPageContent;
